import { AsyncState, Maybe } from 'ballerina-core'
import { CMSImage } from '../../shared/cmsImage/cmsImage.state'
import { Category } from '../cmsPage.state'
import { PictureSources } from '@shared/Frontend/components/picture'
import { CMSLink } from '../../shared/cmsLink/cmsLink.state'

export type TeasersAsync = AsyncState<Maybe<Teasers>>

export type Teasers = { items: Teaser[]; totalCount: number; totalPages: number }

export type TeaserKind = 'search' | 'person' | 'news' | 'standpoints' | 'our-other-views'

export type Teaser = {
  id: string
  title?: string
  intro?: string
  kind: string
  publicationDate?: Date
  categories?: Category[]
  image?: CMSImage
  link: { title: string; url: string }
  pictureSources?: PictureSources
  showType?: boolean
  extraClasses?: string
  titleExtraClasses?: string
}

export type TeaserRelated = {
  title?: string
  image?: CMSImage
  link: { title: string; url: string }
  pictureSources?: PictureSources
  clickableLabel: string
}

export const initialTeasersAsync = (previousOverviewItemsState?: TeasersAsync): TeasersAsync =>
  previousOverviewItemsState || AsyncState.Default.unloaded()
